<script lang="ts" setup>
import img1 from "@/assets/image/services/electricalInstallations/carousel-elektro-daljinski-pristup.png";
import img2 from "@/assets/image/services/electricalInstallations/carousel-elektro-grejanje.jpg";
import img3 from "@/assets/image/services/electricalInstallations/carousel-elektro-kontrola-potrosnje.png";
import img4 from "@/assets/image/services/electricalInstallations/carousel-elektro-rasveta.png";
import img5 from "@/assets/image/services/electricalInstallations/carousel-elektro-roletne.png";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";
import { $te } from "@/assets/ts/helpers";

const store = useDefaultStore();

useHead({
  title: `${$te("app.electricalInstallations.heading")} | ${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${$te("app.electricalInstallations.heading")} | ${store.SITE_NAME}`,
    },
    {
      name: "description",
      content: $te("app.electricalInstallations.paragraph1"),
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${$te("app.electricalInstallations.heading")} | ${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content: $te("app.electricalInstallations.paragraph1"),
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});

const carousel = computed(() => [
  {
    image: img1,
    text: $t("app.electricalInstallations.carousel.1"),
    active: true,
  },
  {
    image: img2,
    text: $t("app.electricalInstallations.carousel.2"),
    active: false,
  },
  {
    image: img3,
    text: $t("app.electricalInstallations.carousel.3"),
    active: false,
  },
  {
    image: img4,
    text: $t("app.electricalInstallations.carousel.4"),
    active: false,
  },
  {
    image: img5,
    text: $t("app.electricalInstallations.carousel.5"),
    active: false,
  },
]);
</script>

<template>
  <m-page class="bg-text-dark">
    <div class="mx-auto max-w-screen-xl">
      <services-page-heading :heading="$t('app.electricalInstallations.heading')"></services-page-heading>
      <services-paragraph class="mb-8 max-w-[779px]" :text="$t('app.electricalInstallations.paragraph1')"></services-paragraph>
      <base-button :text="$t('app.base.contactUs')" route-name="ContactPage" bg-color="text-light" class="mb-12 md:mb-22"></base-button>
      <services-paragraph class="mb-8 max-w-[779px]" :text="$t('app.electricalInstallations.paragraph2')"></services-paragraph>
      <carousel-comp v-if="!store.isWiderThan1307" :carousel="carousel">
        <template #default="{ item, active }">
          <services-image-card :text="item.text ?? ''" :image="item.image" :active="active"></services-image-card>
        </template>
      </carousel-comp>
      <template v-else> <services-wide-carousel :carousel="carousel"></services-wide-carousel> </template>
    </div>
  </m-page>
</template>
